module.exports = __webpack_public_path__ + "static/media/u.ca317bac.png";